import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CommonFunctions } from '@shared/common-functions';
import { BookingService } from '@core/services/booking.service';
import { PaymentStatusForMessage } from '@core/models/api-response.model';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-group-view-booking',
  templateUrl: './group-view-booking.component.html',
  styleUrls: ['./group-view-booking.component.scss'],
})
export class GroupViewBookingComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  imagePath: string = '';
  bookingDetails;
  arrival: Date;
  departure: Date;
  paymentStatus: number;
  paymentInfo: string;
  refundStatus: string;
  role: string;
  bookingType: string;

  constructor(
    public readonly ref: DynamicDialogRef,
    private readonly bookingService: BookingService,
    public readonly config: DynamicDialogConfig,
    private readonly encryptStorage: EncryptionStorageService
  ) { }

  ngOnInit(): void {
    this.role = this.encryptStorage.getItem('roleName');
    this.getGroupBookingDetailById();
    this.refundStatus = this.config.data?.refundStatus;
    this.paymentInfo = this.config.data?.description || '';
    this.bookingType = this.config.data?.bookingType;
  }

  getGroupBookingDetailById(): void {
    
    this.bookingService
      .getGroupBookingDetailById(this.config.data?.bookingId)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          this.bookingDetails = response;
          this.arrival = response.arrivalTime ? new Date(response.arrivalTime.replace(' -', '')) : null;
          this.departure = response.departureTime ? new Date(response.departureTime.replace(' -', '')) : null;
          
        },
      });
  }

  cancelDialog(): void {
    this.ref.close();
  }
  closeSummaryModalOnOutSideClick(): void {
    if (this.ref && this.bookingDetails) {
      this.cancelDialog();
    }
  }

  shouldShowDisputeMessage(paymentStatus: number): boolean {
    return [
      PaymentStatusForMessage.DisputeCreated,
      PaymentStatusForMessage.DisputeUpdated,
      PaymentStatusForMessage.DisputeLoss,
      PaymentStatusForMessage.DisputeExpired
    ].includes(paymentStatus);
  }

  getStatusImage(paymentStatus: number): string {
    switch (paymentStatus) {
      case 2:
        return 'assets/images/check-svg.svg';
      case 4:
        return 'assets/images/in-process.svg';
      case 5:
        return 'assets/images/failed.svg';
      case 1:
      case 3:
      case 6:
      case 8:
      case 10:
        return 'assets/images/pending-icon.svg';
      case 11:
        return 'assets/images/scheduled-icon.svg';
      case 9:
        return 'assets/images/cancelled-icon.svg';
      case 13:
      case 14:
      case 15:
      case 16:
        return 'assets/images/disputed-icon.svg';
      default:
        return '';
    }
  }

  openGatePass(bookingDetails): string {
    return CommonFunctions.openGatePass(this.bookingType, bookingDetails);
  }

  openTruckCheckOutUrl(event: MouseEvent, url: string) {
    event.preventDefault();
    window.open(`${url}`, '_blank');
  }
}
